import axios from '../axios'

/*
 * 用户管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/sysUser/save',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: '/sysUser/edit',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: '/sysUser/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysUser/delete',
    method: 'post',
    data
  })
}
// 分页查询
export const list = (data) => {
  return axios({
    url: '/sysUser/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    noSerializeData: true, // 不序列化参数
    data
  })
}
// 查找用户的菜单权限标识集合
export const findPermissions = (params) => {
  return axios({
    url: '/sysUser/findPermissions',
    method: 'post',
    params
  })
}
// 查找部门人员集合
export const findDeptPersonTree = (params) => {
  return axios({
    url: '/sysUser/findDeptPersonTree',
    method: 'post',
    params
  })
}
// 获取当前登录用户信息
export const findUserInfo = (params) => {
  return axios({
    url: '/userInfo/view',
    method: 'post',
    params
  })
}

// 用户密码重置
export function resetUserPwd(data) {
  return axios({
    url: '/sysUser/resetPwd',
    method: 'put',
    data
  })
}
// 导出
export const exportExcel = (params) => {
  return axios({
    url: '/sysUser/exportExcel',
    method: 'post',
    responseType: 'blob',
    params
  }).then(res => {
    console.log(res)
    if (res) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(res, params.fileName + ".xls");
      } else {
        const elink = document.createElement('a')
        elink.download = params.fileName + ".xls"
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(res)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href) // 释放URL 对象
        document.body.removeChild(elink)
      }
    }
  })
};



// WEBPACK FOOTER //
// ./src/http/moudules/user.js